import { render } from "./AccountApp.vue?vue&type=template&id=30864124"
import script from "./AccountApp.vue?vue&type=script&lang=js"
export * from "./AccountApp.vue?vue&type=script&lang=js"

import "./AccountApp.vue?vue&type=style&index=0&id=30864124&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__